module.exports = __webpack_public_path__ + "static/img/Constellation 1 - Constellations.6921236.png";